var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title"},[_c('ListTitle',{attrs:{"headerNmae":_vm.headerNmaeCh,"headerNmaeCh":_vm.headerNmae}})],1),_c('div',{staticClass:"contentsy contentView"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }